import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IAcaoPlanoAcaoEvidenciaModel, IAcaoPlanoAcaoHistoricoModel, IAcaoPlanoAcaoModel, IAcaoPlanoAcaoRecomendacaoModel, IPlanoAcaoModel } from "./../../../../models/plano-acao-model";
import { PlanoAcaoService } from "./../../../../services/plano-acao.service";
import Swal from "sweetalert2";
import { AuthService } from "./../../../../services/auth.service";
import { BaseFormComponent } from "../../../../shared/components/base-form/base-form.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { IEnumModel } from "../../../../models/enum.model";
import { PlanoAcaoRecomendacaoComponent } from "../../../plano-acao/plano-acao-form/plano-acao-recomendacao/plano-acao-recomendacao.component";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { angularEditorConfig } from "../../../../shared/util/angularEditorConfig";
import { carregarAbasHistorico } from "../../../../shared/util/plano-acao-historico-abas";
import { IResponsavelWithTipoSelectModel } from "../../../../models/responsaveis.model";
import { EnumRecursoPerfil } from "src/app/models/enum/recurso-perfil.enum";
import { EnumAcaoRecurso } from "src/app/models/enum/acao-recurso.enum";


@Component({
  selector: 'app-plano-acao-form-preencher-acao',
  templateUrl: './plano-acao-form-preencher-acao.component.html',
  styleUrls: ['./plano-acao-form-preencher-acao.component.scss']
})

export class PlanoAcaoFormPreencherAcaoComponent extends BaseFormComponent implements OnInit {

  @ViewChild("tabelaRecomendacaoPaginator", { static: true })
  tabelaRecomendacaoPaginator: MatPaginator;
  @ViewChild("tabelaRecomendacaoSort", { static: true })
  tabelaRecomendacaoSort: MatSort;

  @ViewChild("tabelaEvidenciaPaginator", { static: true })
  tabelaEvidenciaPaginator: MatPaginator;
  @ViewChild("tabelaEvidenciaSort", { static: true })
  tabelaEvidenciaSort: MatSort;

  @ViewChild("maxLengthEditor") private angularEditor: any;

  public model = this.createModel();

  public dataSourceRecomendacao = new MatTableDataSource<IAcaoPlanoAcaoRecomendacaoModel>([]);
  public dataSourceEvidencia = new MatTableDataSource<IAcaoPlanoAcaoEvidenciaModel>([]);
  public responsaveis: IResponsavelWithTipoSelectModel[];
  // Demanda 68742 linha 41: ciclos anteriores (somente consulta).
  public historicos: IAcaoPlanoAcaoHistoricoModel[] = [];
  // Aba ativa = ciclo aberto (último sem avaliação); as demais são consulta readonly.
  public numeroAbaAtiva: number = 1;
  public historicosAnteriores: IAcaoPlanoAcaoHistoricoModel[] = [];
  public indiceAba = 0;

  public tituloModal = "";
  public visualizar = false;
  public alterar = false;
  public id: number = 0;
  public planoAcaoId: number = 0;
  public unidadeGestoraId: number = 0;
  public osaExecucaoId: number = 0;
  public avaliacao: number = 1;
  public podeEnviarMonitoramentoPermissao = false;
  public statusSalvoCodigo: number = 0;


  public statusList = [
    { codigo: 6, descricao: "A ser Realizada" },
    { codigo: 7, descricao: "Em Execução" },
    { codigo: 14, descricao: "A ser Enviada" }
  ];

  public statusListVisualizar = [
    { codigo: 6, descricao: "A ser Realizada" },
    { codigo: 7, descricao: "Em Execução" },
    { codigo: 8, descricao: "Concluída" },
    { codigo: 10, descricao: "Atendida Parcialmente" },
    { codigo: 11, descricao: "Não Atendida" },
    { codigo: 14, descricao: "A ser Enviada" }
  ];

  public editorConfig: AngularEditorConfig = angularEditorConfig(
    "Digite a descrição",
    "180px",
    "100%"
  );

  public editorMaxLength = 1000;

  public maxFileSizeMB: number = 30;

  public acceptTypes: string = `
									image/png,
									image/jpeg,
									application/pdf,
									application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
									video/mp4
								`.replace(/\s/g, '');

  constructor(
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    public matDialog: MatDialog,
    public planoAcaoService: PlanoAcaoService,
    public authService: AuthService,
    private dialogRef: MatDialogRef<PlanoAcaoFormPreencherAcaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super(route, toastr, router, localeService, matDialog);

    this.id = data?.id;
    this.visualizar = data?.visualizar;
    this.alterar = data?.alterar;
    this.tituloModal = data?.titulo;
    this.planoAcaoId = data?.planoAcaoId;
    this.unidadeGestoraId = data?.unidadeGestoraId;
    this.osaExecucaoId = data?.osaExecucaoId;
    if (data?.element) {
      this.model = data?.element;
    }
  }

  ngOnInit(): void {

    this.obterResponsaveis(this.unidadeGestoraId);
    if (this.id) {
      this.podeEnviarMonitoramentoPermissao = this.authService.possuiPermissao(
        EnumRecursoPerfil.PlanoDeAcao, EnumAcaoRecurso.enviarParaMonitoramento);
      this.obter(this.id);  
      this.carregarHistorico(this.id);
    }
  }

  // Demanda 68742 linha 41: abas de consulta dos ciclos anteriores.
  public carregarHistorico(acaoId: number): void {
    carregarAbasHistorico((id) => this.planoAcaoService.obterHistoricoAcao(id), acaoId)
      .then((abas) => {
        this.historicos = abas.historicos;
        this.numeroAbaAtiva = abas.numeroAbaAtiva;
        this.historicosAnteriores = abas.historicosAnteriores;
      });
  }

  public obterResponsaveis(id: any) {

    this.responsaveis = [];

    this.planoAcaoService.obterResponsaveis(id).then((res) => {
      if (res.sucesso) {
        this.responsaveis = res.dados;
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    })
  }


  private createModel(): IAcaoPlanoAcaoModel {
    return {
      id: 0,
      planoAcaoId: this.planoAcaoId,
      planoAcao: {} as IPlanoAcaoModel,
      identificador: 0,
      titulo: '',
      descricao: '',
      responsavelId: '',
      responsavelNome: '',
      prazo: new Date,
      status: { codigo: 1, nome: 'Cadastrada', descricao: 'Cadastrada' } as IEnumModel,
      justificativaAvaliacao: '',
      nivelRelevancia: null,
      comentarioAuditor: '',
      descricaoImplementacao: '',
      dataRealizacao: null,
      descricaoImplementacaoAuditor: '',
      avaliacao: null,
      dataMonitoramento: null,
      responsavelIdMonitoramento: '',
      responsavelNomeMonitoramento: '',
      responsavelCargoMonitoramento: '',
      recomendacoes: [],
      evidencias: [],
      evidenciasAuditor: [],
      adicionadaAposAvaliacao: false
    };
  }

  public obter(id: number) {

    this.planoAcaoService
      .obterAcaoPorId(id)
      .then((res) => {
        if (res.sucesso) {
          this.model = res.dados;
          this.statusSalvoCodigo = this.model.status?.codigo;

          this.model.prazo = new Date(this.model.prazo);
          this.avaliacao = this.model.status.codigo;

          if (this.model.dataRealizacao)
            this.model.dataRealizacao = new Date(this.model.dataRealizacao);

          //if (this.model.status.codigo != 6 && this.model.status.codigo != 7 && this.model.status.codigo != 8)
          //{
          //    this.model.status = null;
          //}

          this.dataSourceRecomendacao.data = this.model?.recomendacoes;
          this.dataSourceRecomendacao.paginator = this.tabelaRecomendacaoPaginator;
          this.dataSourceRecomendacao.sort = this.tabelaRecomendacaoSort;
          this.dataSourceRecomendacao.sortingDataAccessor = this.sortingDataAccessor;

          this.dataSourceEvidencia.data = this.model?.evidencias;
          this.dataSourceEvidencia.paginator = this.tabelaEvidenciaPaginator;
          this.dataSourceEvidencia.sort = this.tabelaEvidenciaSort;
          this.dataSourceEvidencia.sortingDataAccessor = this.sortingEvidenciaDataAccessor;

        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }


  get mostrarEnviarMonitoramento(): boolean {
    return !this.visualizar && this.statusSalvoCodigo === 14;
  }
  public sortingDataAccessor = (item, property) => {
    switch (property) {
      case "titulo":
        return item.recomendacao.titulo;
      default:
        return item[property];
    }
  };

  public sortingEvidenciaDataAccessor = (item, property) => {
    switch (property) {
      case "nome":
        return item.evidencia.nome;
      default:
        return item[property];
    }
  };


  public modalRecomendacao(element?: IAcaoPlanoAcaoRecomendacaoModel) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-plano-acao-acao-recomendacao";
    dialogConfig.width = "50vw";
    dialogConfig.height = "45vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo: "Visualizar Recomendação",
      element
    };

    const modal = this.matDialog.open(PlanoAcaoRecomendacaoComponent, dialogConfig);

    modal.afterClosed().subscribe((data) => {
      if (data) {
      }
    });
  }

  public salvar() {

    if ((!this.model.status) || (this.model.status.codigo != 6 && this.model.status.codigo != 7 && this.model.status.codigo != 14)) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "selecione um dos status: A ser Realizada, Em Execução ou A ser Enviada!",
      });
      return;
    }

    if (!this.model.responsavelId) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Responsável da Ação não informado!",
      });
      return;
    }

    if (this.obterQuantidadeCaracteres(this.model.descricaoImplementacao) > 1000) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "O campo Descrição da Implementação da Ação tem um limite de 1000 caracteres e foi atingido, por favor ajuste!",
      });
      return;
    }

    //-> Preenche a ação
    this.planoAcaoService
      .preencherAcao(this.model)
      .then((res) => {
        if (res.sucesso) {

          this.dialogRef.close(true);

          Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            icon: "success",
            text: res.mensagem.descricao,
          });
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  public enviar() {

    if (!this.model.responsavelId) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "O campo Responsável da Ação é obrigatório!",
      });
      return;
    }

    if (!this.model.dataRealizacao) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "O campo Data da Realização é obrigatório!",
      });
      return;
    }

    if (!this.model.descricaoImplementacao) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "O campo Descrição da Implementação da Ação é obrigatório!",
      });
      return;
    }

    if (this.model.evidencias.length === 0) {
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        icon: "warning",
        text: "Pelo menos 1(uma) evidência deve ser adicionada!",
      });
      return;
    }

    //-> seta o status para concluida
    this.model.status = { codigo: 8, descricao: "Concluída", nome: 'Concluida' } as IEnumModel;

    //-> enviar a acao para monitoramento
    this.planoAcaoService
      .enviarAcaoParaMonitoramento(this.model)
      .then((res) => {
        if (res.sucesso) {

          this.dialogRef.close(true);

          Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            icon: "success",
            text: res.mensagem.descricao,
          });
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "warning",
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }



  public fechar() {
    this.dialogRef.close();
  }

  public cancelar() {
    Swal.fire({
      title: "Cancelar",
      text: "Todas os dados não salvos serão perdidos. Deseja continuar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {
      if (res.value) {
        this.dialogRef.close();
      }
    });
  }

  ngAfterViewInit() {

    function maxLengthAngularEditor(e: any) {
      var element = e.target as HTMLTextAreaElement;
      let permitirTeclas =
        e.key !== "Backspace" &&
        e.key !== "ArrowLeft" &&
        e.key !== "ArrowRight";
      if (element.innerHTML.length === 1000 && permitirTeclas) {
        e.preventDefault();
      }
    }

    this.angularEditor?.textArea?.nativeElement.addEventListener(
      "keydown",
      maxLengthAngularEditor,
      false
    );
  }

  onEditorChange(content: string) {
    if (content.length > this.editorMaxLength) {
      // corta automaticamente para 1000 caracteres
      this.model.descricaoImplementacao = content.substring(0, this.editorMaxLength);
    }
  }

  onEditorKeyDown(event: KeyboardEvent) {
    if (this.model.descricaoImplementacao?.length >= this.editorMaxLength &&
      event.key !== 'Backspace' && event.key !== 'Delete') {
      event.preventDefault(); // bloqueia a digitação
    }
  }

  private obterQuantidadeCaracteres(html: string): number {

    if (!html) {
      return 0;
    }

    const div = document.createElement('div');
    div.innerHTML = html;

    const texto = (div.textContent || div.innerText || '')
      .replace(/\u00A0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return texto.length;
  }


  //#region Evidencias

  public async incluirEvidencias(e: any) {

    const files = (e.target as HTMLInputElement).files;
    if (!files || files.length === 0) return;

    const maxBytes = this.maxFileSizeMB * 1024 * 1024;
    const acceptedTypes = this.acceptTypes.split(',').map(type => type.trim());

    const flatListFiles = Array.from(files);

    for (let i = 0; i < flatListFiles.length; i++) {

      const file = flatListFiles[i];

      // ✅ Validação de tamanho
      if (file.size > maxBytes) {
        alert(`O arquivo "${file.name}" excede o tamanho máximo de ${this.maxFileSizeMB} MB.`);
        continue;
      }

      // ✅ Validação de tipo
      if (!acceptedTypes.includes(file.type)) {
        alert(`O tipo do arquivo "${file.name}" (${file.type}) não é permitido. São permitidos apenas arquivos PNG, JPG, PDF, XLSX E MP4.`);
        continue;
      }

      const fileToArray = await this.getBase64(file);

      // adiciona na grade
      const novaEvidencia: IAcaoPlanoAcaoEvidenciaModel = {
        id: 0,
        acaoId: this.id,
        acao: {} as IAcaoPlanoAcaoModel,
        tipo: file.type,
        nome: file.name,
        arquivo: fileToArray.toString(),
        link: ''
      };

      this.model.evidencias.push(novaEvidencia);
    }
    this.dataSourceEvidencia.data = [...this.model.evidencias];
  }

  public getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          text:
            "Ocorreu um erro ao selecionar o arquivo" +
            error.toString(),
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      };
    });
  }

  public excluirEvidencia(index: number) {

    Swal.fire({
      title: "Excluir Evidência ?",
      text: "Confirma exclusão da Evidência?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.isConfirmed) {
        this.model.evidencias?.splice(index, 1);
        this.dataSourceEvidencia.data = [...this.model.evidencias];
      }
    });
  }

  public Download(evidencia: IAcaoPlanoAcaoEvidenciaModel) {
    this.planoAcaoService.downloadEvidencia(evidencia.id).then((res) => {
      if (res.sucesso) {
        const link = document.createElement("a");
        link.href = res.dados.link.toString();
        link.download = res.dados.nome;
        link.click();
      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    })
  }

  //#endregion Evidencias
}


